var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"pipe-overlay-portal",style:(_vm.style),attrs:{"viewBox":_vm.viewBox}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }